module.exports = __webpack_public_path__ + "img/Jinhui_Tang@2x.3c10ed89.png";